<template>
    <div>
        <!-- <div class="d-flex justify-content-between align-items-center p-4">
            <div class="d-flex justify-content-between align-items-center">
                <span class="text-secondary fw-600 mr-4"><span>Ticket</span> #50205</span>
                <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/info-24px.svg" alt="" style="height:20px;">
                <span class="text-secondary fw-600 ml-4">CRM Edit Bug Not Working</span>
            </div>
            <div>
                <button class="btn btn-secondary btn-smm ml-2 text-white fs-14">
                    <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/prefix__edit.svg" alt="" style="height:15px;margin-bottom:3px;margin-right:4px">
                    Edit
                </button>
                <button class="btn btn-warning btn-smm ml-2 text-white fs-14">
                    <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/share.svg" alt="" style="height:15px;margin-bottom:3px;margin-right:4px">
                    Share
                </button>
            </div>
        </div> -->
        <div class="comment_conversion" @scroll="infiniteScroll">
            <div class="py-5 w-100">
                <div v-if="ajaxCallInProgress" class="d-flex align-items-center justify-content-center w-100" style="height: 100vh !important;">
                    <!-- <div class="digi-table-loader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div> -->
                    <img class="mt-5 mb-5" src="/static/images/new-theme2024/20 card.gif" width="100" alt="digi-loader">
                </div>
                <template v-else-if="!ajaxCallInProgress && all_activity.length == 0">
                    <div>No Activity Found</div>
                </template>
                <div v-else class="w-100">
                    <table class="table">
                        <thead>
                            <tr>
                            <th class="fw-700 fs-15 text-black-shade text-transform-none">Activity Log</th>
                            <th class="fw-600 fs-14 pr-8 text-black-shade text-transform-none" style="min-width: 180px; width: 180px">Data & Timestamp</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(activity,index) in all_activity" :key="index">
                                <td class="border-bottom-col">
                                    <div class="d-flex align-items-center">
                                        <!-- <avatar
                                            :username="activity.full_name"
                                            :src="''"
                                            :size="35"
                                            :rounded="true"
                                            style="background-color: #c4d9f8; min-width: 35px; width: 35px; height: 35px;"
                                            class="font-weight-600"
                                            color="#00448b"
                                        ></avatar> -->
                                        <div class="">
                                            <span class="fw-600 whiteSpace text-black-shade fs-14" style="word-break: break-all;">{{activity.activity}}</span>
                                            <span class="fw-500 fs-14 ml-1 text-primary-shade" style="word-break: break-all;">{{activity.ticket_number}}</span>
                                            <!-- <span class="font-weight-500 fs-14 ml-2" style="word-break: break-all;">
                                                <button type="button" class="btn btn-secondary text-white btn-smm" style="box-shadow: none;border-radius:4px" @click="showActivityPopUp(activity.activity_id)">
                                                    View More
                                                </button>
                                            </span> -->
                                        </div>
                                    </div>
                                </td>
                                <td class="border-bottom-col mw-180px w-180px">
                                    <span class="today-span fw-500 text-black-shade">{{activity.created_date.split(' ')[0]}} </span>
                                    <span class="today-span fw-500 text-black-shade">{{activity.created_date.split(' ')[1] + ' ' +  activity.created_date.split(' ') [2] }} </span>
                                    <span class="date-span fw-500 text-black-shade">{{activity.created_date.split(' ')[3] + ' ' +  activity.created_date.split(' ') [4] }}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- <ul v-else class="timeline">  
                    <li class="event justify-content-between align-items-center"  v-for="(activity,index) in all_activity" :key="index">
                        <span class="greencircle">  
                            <span class="fs-15">{{activity.created_date.split(' ')[0]}}</span> 
                            <span>{{activity.created_date.split(' ')[1] + ' ' +  activity.created_date.split(' ') [2] }}</span> 
                            <span>{{activity.created_date.split(' ')[3] + ' ' +  activity.created_date.split(' ') [4] }}</span> 
                        </span>
                        <div class="mb-2 activityTitle d-flex align-items-end">    
                            <span class="curve"></span>
                            <div class="unfinishedCircleText pointer">
                                <div class="activityname">
                                    <p class="mb-0 text-capitalize">{{activity.activity}} </p>
                                </div>
                                <div>
                                    <span class="text-secondary">Action : </span>
                                    <span class="text-capitalize">{{activity.action}}</span> 
                                </div>
                            </div>
                            <span class="ml-2">
                                <button type="button" class="btn btn-secondary text-white btn-smm" style="box-shadow: none;border-radius:4px" @click="showActivityPopUp(activity.activity_id)">
                                    View More
                                </button>
                            </span>
                        </div>
                    </li>
                </ul>     -->
            </div>
        <ticket-activity-modal modal_name="ticket-activity-modal" v-if="showActivity" :activity_id="activity_id" @activityByIdHide="activityByIdHide"></ticket-activity-modal>
        </div>
    </div>
</template>
<script>
import ticket from '../mixins/ticket.js';
import TicketActivityModal from "./TicketAcitivityModal";
export default {
    mixins:[ticket],
    props:["showDetails", "ticket_id"],
    components:{
        TicketActivityModal
    },
    data(){
        return{
            all_activity:[],
            ajaxCallInProgress:false,
            activity_id:null,
            showActivity:false,
            activity_count: 0,
        }
    },
    methods:{
        activityByIdHide(){
            this.activity= null
            this.showActivity = false
        },
        showActivityPopUp(id){
            this.activity_id = id
            this.showActivity = true
            setTimeout(() => {
                this.$modal.show('ticket-activity-modal')
            }, 1000);
        },
        async getDetails(param){
            try {
                this.ajaxCallInProgress = true
                let params={
                    ticket_id : this.showDetails.ticket_id || this.ticket_id,
                    skip: this.activity_count,
                    limit: 10
                }
                let res = await this.getAllActivity(params)
                this.all_activity = res.response.activities
                this.activity_count += res.response.activities.length
                this.ajaxCallInProgress = false
                // this.all_activity.forEach((el,index)=>{
                //     let name  = el.activity.split(' ')
                //     el['userName'] = name[0]
                // })
            } catch (reason) {
                console.log(reason)
            }
        },
        async infiniteScroll(e) {
            const {
                target
            } = e;
            if (Math.ceil(target.scrollTop) >= target.scrollHeight - target.offsetHeight) {
                try {
                    let params = {
                        ticket_id : this.showDetails.ticket_id,
                        skip: this.activity_count,
                        limit: 10,
                    }
                    let res = await this.getAllActivity(params)
                    if (res.response.skip == this.activity_count) {
                        let tempFiles = res.response.activities
                        tempFiles.forEach((e) => {
                            this.all_activity.push(e)
                        })
                        this.activity_count += res.response.activities.length
                    }
                } catch (reason) {
                    console.log(reason)
                }
            }
        },
    },
    async mounted(){
        this.getDetails()
    }
}
</script>
<style scoped>

.comment_conversion{
    /* border: 1.5px solid #aac6ee; */
    border-bottom: none;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    display: flex;
    justify-content: left;
    max-height: 500px;
    overflow-y: scroll;
}
.timeline {
    border-left: 1px solid #25bb83;
    border-bottom-right-radius: 4px;
    border-top-right-radius: 4px;
    background: rgba(255, 255, 255, 0.03);
    color: rgba(255, 255, 255, 0.8);
    position: relative;
    left:35px;
    line-height: 1.4em;
    overflow-x: initial;
    font-size: 14px;
    padding: 0px 0px 3px 50px;
    list-style: none;
    text-align: left;
    font-weight: 100;
}
.timeline .event {
    border-bottom: 1px dashed rgba(255, 255, 255, 0.1);
    padding-bottom: 25px;
    margin-bottom: 25px;
    position: relative;
}
.timeline .event:last-of-type {
    padding-bottom: 0;
    margin-bottom: 0;
    border: none;
}
.timeline .event:before,
.timeline .event:after {
    position: absolute;
    display: block;
    top: 0;
}
.activityTitle {
    font-size: 14px;
    color: #000000 !important;
    font-weight: normal;
    position: relative;
    right: 5px;
    bottom: -10px;
}
.curve{
    border: solid transparent;
    border-top-color: transparent;
    border-top-width: medium;
    border-right-width: medium;
    border-bottom-width: medium;
    border-left-width: medium;
    border-width: 10px;
    border-right-color: #e7e7e7;
}
.unfinishedCircleText {
    max-width: 500px !important;
  font-size: 14px;  
  color: #000000 !important;
  padding: 10px;
  border-radius: 5px;
  background-color:#e7e7e7;
  display: flex;
  flex-direction: column;
} 
.timeline .event .greencircle{
  color: #ffffff !important;
  text-align: right;
  font-weight: 500;
  font-size: 12px;
  text-align: right;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center; 
  left: -85.5px;
  position: absolute;
  z-index: 1;
  top: 0px;
  background: #25bb83;
  border-radius: 50%;
  height: 70px;
  width: 70px;
} 
.timeline .event .bluecircle{
  color: #ffffff !important;
  text-align: right;
  font-weight: 500;
  font-size: 12px;
  text-align: right;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center; 
  left: -85.5px;
  position: absolute;
  z-index: 1;
  top: 0px;
  background: #005dae;
  border-radius: 50%;
  height: 70px;
  width: 70px;
} 
.timeline .event .yellowcircle{
  color: #ffffff !important;
  text-align: right;
  font-weight: 500;
  font-size: 12px;
  text-align: right;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center; 
  left: -85.5px;
  position: absolute;
  z-index: 1;
  top: 0px;
  background: #f9a825;
  border-radius: 50%;
  height: 70px;
  width: 70px;
}
</style>